import Handsontable from "handsontable";
import AppColors from "../../../../constants/AppColors";

class AuditSheetEditor extends Handsontable.editors.NumericEditor {
  init() {
    super.init()
  }
}

function getScaledRowFontSize(scale) {
  return (14 * scale) + 'px';
}

function customDropdownRenderer(instance, td, row, col, prop, value, cellProperties) {
  // td.style.textAlign = 'center';
  td.style.fontSize = getScaledRowFontSize(cellProperties?.scale);
  Handsontable.renderers.AutocompleteRenderer(instance, td, row, col, prop, value, cellProperties)
}

function currencyRenderer(instance, td, row, col, prop, value, cellProperties) {
  if (value && !''.startsWith('$')) {
    value = `$${value}`;
  }

  td.style.textAlign = 'center';
  td.style.fontSize = getScaledRowFontSize(cellProperties?.scale);
  td.style.background = AppColors.lightPink
  Handsontable.renderers.TextRenderer(instance, td, row, col, prop, value, cellProperties);
}

export function registerCustomCells({ scale }) {
  Handsontable.cellTypes.registerCellType('audit_sheet.currency_renderer', {
    editor: AuditSheetEditor,
    renderer: currencyRenderer,
    validator: Handsontable.validators.NumericValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    type: 'numeric',
    scale: scale,
  });

  Handsontable.cellTypes.registerCellType('audit_sheet.dropdown_renderer', {
    editor: Handsontable.editors.DropdownEditor,
    renderer: customDropdownRenderer,
    validator: Handsontable.validators.AutocompleteValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    scale: scale,
  });

  Handsontable.cellTypes.registerCellType('audit_sheet.currency_renderer', {
    editor: AuditSheetEditor,
    renderer: currencyRenderer,
    validator: Handsontable.validators.NumericValidator,
    // You can add additional options to the cell type
    // based on Handsontable settings
    allowInvalid: false,
    type: 'numeric',
    scale: scale,
  });

  Handsontable.renderers.registerRenderer(
    'hoverCPTRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
    if (value && cellProperties.CPT) {
      try{
        const codeOnly = value.split('*')[0];
        TD.setAttribute('title', `${cellProperties.CPT[codeOnly].description.replace(/\s+/g, ' ').trim()}`);
        TD.classList.add('ht-tooltip');
      }catch{
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    } else {
      TD.removeAttribute('title');
      TD.classList.remove('ht-tooltipp');
    }
    }
  );  
  Handsontable.renderers.registerRenderer(
    'hoverICDRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
      if (value && cellProperties.ICD) {
        try{
          TD.setAttribute('title', `${cellProperties.ICD[value].description.replace(/\s+/g, ' ').trim()}`);
          TD.classList.add('ht-tooltipp');
        }catch{
          TD.removeAttribute('title');
          TD.classList.remove('ht-tooltipp');
        }
      } else {
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    }
  );
  Handsontable.renderers.registerRenderer(
    'hoverModifierRenderer',
    (hotInstance, TD, row, column, prop, value, cellProperties) => {
      // Use the default text renderer
      Handsontable.renderers.getRenderer('text')(
        hotInstance,
        TD,
        row,
        column,
        prop,
        value,
        cellProperties
      );
  
      // Add a tooltip only if `description` exists
      TD.style.textAlign = 'center';
      if (value && cellProperties.Modifiers) {
        try{
          const modifiers = value.split(',').map(mod => mod.trim()); // Split and trim each value
          let descriptions = '';
          if(modifiers.length >1){
            descriptions = modifiers.map(mod => 
              `${mod}: ${cellProperties.Modifiers[mod]?.description.replace(/\s+/g, ' ').trim() || ''}`
            ).join('\n');
          }else{
            descriptions = cellProperties.Modifiers[modifiers[0]]?.description.replace(/\s+/g, ' ').trim() || ''
          }
          TD.setAttribute('title', descriptions);
          TD.classList.add('ht-tooltipp');
        }catch{
          TD.removeAttribute('title');
          TD.classList.remove('ht-tooltipp');
        }
      } else {
        TD.removeAttribute('title');
        TD.classList.remove('ht-tooltipp');
      }
    }
  ); 
}
